module.exports = __webpack_public_path__ + "img/fingerprint_recording_sheet_image.a5c17176.jpg";